export const ModalImage = {
  UNLINK_CONFIRMATION_ICON: 'unlink-confirmation-icon',
  INFO_NOTIFICATION_ICON: 'info-notification-icon',
  WARNING_NOTIFICATION_ICON: 'warning-notification-icon',
  WARNING_CONFIRMATION_ICON: 'warning-confirmation-icon',
  WARNING_NO_INTERNET_ICON: 'warning-no-internet-icon',
  WARNING_REQUEST_TIMEOUT_ICON: 'warning-request-timeout-icon',
  WARNING_TOKEN_EXPIRED_ICON: 'warning-token-expired-icon',
}
